import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import * as api from '../../api/api';
import * as utils from '../../utils';

class Footer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clientVersion: utils.getClientVersion(),
            serverVersion: {
                app: 'н/д',
                git: 'н/д',
            },
        }
    }
    async componentDidMount() {
        try {
            const serverVersion = (await api.makeRequest(api.getServerVersion())).data.data;
            this.setState({
                serverVersion,
            });
        }
        catch (err) {
            console.log(err);
        }
    }

    render() {
        return (
            <footer className="bg-dark text-light p-3">
                <div className="d-flex justify-content-between">
                    <div>
                        {/* <p>&copy; {new Date().getFullYear()} ТИУ, Центр компетенций Интернета вещей и Smart City<br/>Все права защищены</p> */}
                        <p>&copy; {new Date().getFullYear()} IMMS72 Team<br />Все права защищены</p>
                    </div>
                    <div className={utils.getIsViewportEqual("xs", "sm") ? "d-none" : ""}>
                        <p>
                            Сервер: {`${this.state.serverVersion.app}+git${this.state.serverVersion.git}`}<br />
                            Клиент: {`${this.state.clientVersion.app}+git${this.state.clientVersion.git}`}
                        </p>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;


{/* <footer className = "mt-auto bg-dark text-light p-3"> */ }